import { render, staticRenderFns } from "./ShopFooter.vue?vue&type=template&id=0e2f8669"
import script from "./ShopFooter.vue?vue&type=script&lang=js"
export * from "./ShopFooter.vue?vue&type=script&lang=js"
import style0 from "./ShopFooter.vue?vue&type=style&index=0&id=0e2f8669&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports